import { PATH_SCHEDULING_STUDIO } from '../../../router/routes';
import { CreateEditView, CreateEditViewType } from '../../../types';

const createPathname = (action: CreateEditViewType, id?: string, composer?: boolean) => {
  let pathname = `${PATH_SCHEDULING_STUDIO}/${action}`;

  if (composer) {
    pathname = `${pathname}/composer`;
  }

  if (id && action !== CreateEditView.CREATE) {
    pathname = `${pathname}/${id}`;
  }

  return pathname;
};

export const getPathname = (action: CreateEditViewType, id?: string) => createPathname(action, id);
export const getComposerPathname = (action: CreateEditViewType, id?: string) => createPathname(action, id, true);
